import React from "react";
import "./ImageViewer.css";

export default function ImageViewer({ onClose, imageName }) {
  const imageSrc = "/logokarel.png";

  return (
    <div className="image-viewer-overlay" onClick={onClose}>
      <div className="image-viewer-window" onClick={(e) => e.stopPropagation()}>
        <div className="image-viewer-topbar">
          <div className="image-viewer-buttons">
            <span className="close" onClick={onClose}></span>
            <span className="minimize"></span>
            <span className="maximize"></span>
          </div>
          <span className="image-viewer-title">{imageName}</span>
        </div>
        <div className="image-viewer-content">
          <img src={imageSrc} alt={imageName} />
        </div>
      </div>
    </div>
  );
}
